import { onDocumentReady } from '../utils/events';
import Splide from '@splidejs/splide';
import { AdjustableHeight } from '../utils/splide-auto-height';

onDocumentReady(() => {
  const sliderEl = document.querySelector('.latest-posts__items');

  if (sliderEl) {
    const splide = new Splide(sliderEl, {
      type: 'loop',
      perMove: 1,
      perPage: 3,
      gap: '1.875rem',
      drag: true,
      flickPower: 150,
      dragMinThreshold: {
        mouse: 40,
        touch: 70,
      },
      arrows: true,
      pagination: false,
      keyboard: 'focused',
      rewind: true,
      focus: 0,
      breakpoints: {
        1200: {
          perPage: 2,
        },
        1024: {
          gap: '1.25rem',
        },
        768: {
          perPage: 1,
        },
        640: {
          pagination: false,
        },
      },
    });
    splide.mount({ AdjustableHeight });
  }
});
